import { render, staticRenderFns } from "./MutualFundItem.vue?vue&type=template&id=591ff92f&scoped=true&"
import script from "./MutualFundItem.vue?vue&type=script&lang=js&"
export * from "./MutualFundItem.vue?vue&type=script&lang=js&"
import style0 from "./MutualFundItem.vue?vue&type=style&index=0&id=591ff92f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591ff92f",
  null
  
)

export default component.exports